
import { defineComponent } from "vue";
import { mapGetters } from "vuex";
import keyStore from "Store/keyStore";
import { IConfirmParameter } from "Helpers/notification";
const confirmDefault: IConfirmParameter = {
  title: "",
  message: "",
  cancelButton: "Cancel",
  acceptButton: "Ok",
};

export default defineComponent({
  computed: {
    ...mapGetters({
      confirm_getters: keyStore.CONFIRM,
    }),
    notification() {
      const confirmGetters = this.confirm_getters as IConfirmParameter;
      var notify = Object.assign({}, confirmDefault, confirmGetters);
      return notify;
    },
  },
  methods: {
    togglePopup() {
      $(this.$refs.modalConfirm).modal("toggle");
    },
    onClick(val: boolean) {
      this.callBackInvoke(val);
      this.togglePopup();
    },
    callBackInvoke(val: boolean) {
      const callBack = this.notification.callBack;
      if (callBack != null) {
        callBack(val);
      }
    },
  },
  watch: {
    notification: function (newValue) {
      this.togglePopup();
    },
  },
  mounted() {
    const vm = this;
    const modal = vm.$refs.modalConfirm;
    $(modal)
      .off("hide.bs.modal")
      .on("hide.bs.modal", function () {
        vm.callBackInvoke(false);
      });
  },
});
